import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Mail } from 'lucide-react';
import { Button } from '../ui/Button';
export function LocationCTA() {
  return <section id="location" className="py-24 bg-zinc-950 relative overflow-hidden" data-id="element-75">
      <div className="container mx-auto px-6" data-id="element-76">
        <div className="bg-zinc-900 border border-zinc-800 p-8 md:p-16 flex flex-col lg:flex-row gap-12 items-center relative overflow-hidden" data-id="element-77">
          {/* Decorative background element */}
          <div className="absolute -right-20 -top-20 text-[20rem] font-display text-zinc-800/20 leading-none pointer-events-none" data-id="element-78">
            8
          </div>

          <div className="lg:w-1/2 relative z-10" data-id="element-79">
            <h2 className="font-display text-5xl md:text-6xl text-white uppercase mb-6" data-id="element-80">
              Ready to <span className="text-red-600" data-id="element-81">Work?</span>
            </h2>
            <p className="text-zinc-400 text-lg mb-10" data-id="element-82">
              Stop making excuses. Come down to the gym, meet the coaches, and
              see what real Muay Thai training looks like.
            </p>

            <div className="space-y-6 mb-10" data-id="element-83">
              <div className="flex items-start gap-4" data-id="element-84">
                <MapPin className="text-red-600 shrink-0 mt-1" data-id="element-85" />
                <div data-id="element-86">
                  <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-1" data-id="element-87">
                    Location
                  </h4>
                  <p className="text-zinc-400" data-id="element-88">
                    2800 Main St.
                    <br data-id="element-89" />
                    Deep Ellum, Dallas, TX 75226
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-90">
                <Clock className="text-red-600 shrink-0 mt-1" data-id="element-91" />
                <div data-id="element-92">
                  <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-1" data-id="element-93">
                    Hours
                  </h4>
                  <p className="text-zinc-400" data-id="element-94">
                    Mon-Fri: 6AM - 9PM
                    <br data-id="element-95" />
                    Sat: 8AM - 2PM
                    <br data-id="element-96" />
                    Sun: Open Mat Only
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-97">
                <Mail className="text-red-600 shrink-0 mt-1" data-id="element-98" />
                <div data-id="element-99">
                  <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-1" data-id="element-100">
                    Contact
                  </h4>
                  <p className="text-zinc-400" data-id="element-101">
                    info@ironeightmt.com
                    <br data-id="element-102" />
                    (214) 555-0198
                  </p>
                </div>
              </div>
            </div>

            <Button size="lg" onClick={() => document.getElementById('memberships')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-103">
              Join The Gym
            </Button>
          </div>

          <div className="lg:w-1/2 w-full relative z-10" data-id="element-104">
            {/* Styled map placeholder to fit the dark aesthetic without needing a real Google Maps API key */}
            <div className="aspect-video lg:aspect-square bg-zinc-950 border border-zinc-800 relative overflow-hidden group flex items-center justify-center" data-id="element-105">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(#3f3f46 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-106"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950 to-transparent" data-id="element-107"></div>

              <div className="relative z-10 flex flex-col items-center" data-id="element-108">
                <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mb-4 animate-pulse" data-id="element-109">
                  <div className="w-4 h-4 bg-red-600 rounded-full" data-id="element-110"></div>
                </div>
                <div className="bg-zinc-900 border border-zinc-800 px-4 py-2 text-sm text-white font-display tracking-widest uppercase" data-id="element-111">
                  Deep Ellum, TX
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}